// ============================================================================
// HINDI TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// मजेदार लेकिन विचारशील प्रश्न

export const funQuestions = [
  {
    question: "अगर यीशु के पास फोन होता, तो उनका पहला संपर्क कौन होता?",
    emoji: "📱",
    theme: "दिव्य_संबंध"
  },
  {
    question: "दाऊद ने कभी अपनी भेड़ें क्यों नहीं खोईं?",
    emoji: "🐑", 
    theme: "चरवाहा"
  },
  {
    question: "परमेश्वर का प्रेम कितने में मिलता है?",
    emoji: "💰",
    theme: "अनुग्रह"
  },
  {
    question: "परमेश्वर की शांति और झपकी में क्या अंतर है?",
    emoji: "😴",
    theme: "शांति"
  },
  {
    question: "परमेश्वर का वचन कभी बैटरी खत्म क्यों नहीं होता?",
    emoji: "🔋",
    theme: "वचन"
  },
  {
    question: "अगर मूसा के पास GPS होता, तो क्या वह 40 साल रेगिस्तान में भटकते?",
    emoji: "🗺️",
    theme: "मार्गदर्शन"
  },
  {
    question: "स्वर्गदूतों को कभी व्यायाम करने की ज़रूरत क्यों नहीं पड़ती?",
    emoji: "👼",
    theme: "पूर्णता"
  },
  {
    question: "सुलैमान आधुनिक सोशल मीडिया के बारे में क्या कहेंगे?",
    emoji: "📱",
    theme: "बुद्धि"
  }
];

export default funQuestions;
